export enum TailscaleRoutes {
  CreateAuthKey = 'create-auth-key',
}
